import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

// The site-level half of the blog: its authors and its three templates. Read
// here, written through the site's own update (SiteInputUpdate.blog) — see the
// Authors screen and the Templates screens.
export const BlogAuthorFragment = gql`
  fragment BlogAuthorFragment on BlogAuthor {
    authorId
    name
    image
    bio
  }
`;

// Resolved on the API: the site's own or the built-in, and \`builtin\` says
// which. The three code fields are a page of text each, so this fragment is
// asked for by the screens that show a template and not by the blog's tabs.
export const BlogTemplateFragment = gql`
  fragment BlogTemplateFragment on BlogTemplate {
    id
    kind
    html
    style
    script
    builtin
  }
`;

export const templates = gql`
  query BlogTemplates($siteId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              templates {
                ...BlogTemplateFragment
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogTemplateFragment}
`;

export const authors = gql`
  query BlogAuthors($siteId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              authors {
                ...BlogAuthorFragment
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogAuthorFragment}
`;

// Saving the authors or a template goes through the site's update, whose
// evictor clears `sites/queries`; the blog namespace hangs off the site row,
// so this clears the authors and templates reads too.
export const update = () => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`blog/queries`) || key.includes(`sites/queries`)) {
      cache.data.delete(key);
    }
  });
};
